<template>
  <div :style="[backgroud]">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <template v-if="!$route.meta.keepAlive && isElectron !== null">
      <router-view v-if="isElectron" :key="$route.path"> </router-view>
      <router-view v-else></router-view>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isElectron: null,
    };
  },
  computed: {
    backgroud() {
      return (
        this.$route.meta.backgroud || {
          background: "",
        }
      );
    },
    key() {
      return this.$route.path + Math.random();
    },
  },
  created() {
    this.isElectron = Boolean(window.isElectron);
  },
};
</script>
